(function (root, factory) {
  'use strict';

  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FunnyHooksEventsStructuredContent = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var DEFAULT_SUMMARY_LENGTH = 160;
  var IMAGE_FALLBACK_KEY = 'event_content.image_fallback';

  var OPTIONAL_SECTION_SPECS = [
    {
      key: 'included_items',
      labelKey: 'event_content.included_items',
      kind: 'list',
      aliases: ['included_items', 'includedItems']
    },
    {
      key: 'what_to_bring',
      labelKey: 'event_content.what_to_bring',
      kind: 'list',
      aliases: ['what_to_bring', 'whatToBring']
    },
    {
      key: 'audience',
      labelKey: 'event_content.audience',
      kind: 'text',
      aliases: ['audience']
    },
    {
      key: 'cancellation_policy',
      labelKey: 'event_content.cancellation_policy',
      kind: 'text',
      aliases: ['cancellation_policy', 'cancellationPolicy']
    },
    {
      key: 'contact',
      labelKey: 'event_content.contact',
      kind: 'contact',
      aliases: ['contact_path', 'contactPath', 'contact']
    }
  ];

  function stringValue(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function decodeTextEntities(value) {
    return value.replace(/&(#(?:x[0-9a-f]+|[0-9]+)|amp|lt|gt|quot|apos|nbsp);/gi, function (match, entity) {
      var normalized = entity.toLowerCase();
      if (normalized === 'amp') return '&';
      if (normalized === 'lt') return '<';
      if (normalized === 'gt') return '>';
      if (normalized === 'quot') return '"';
      if (normalized === 'apos') return "'";
      if (normalized === 'nbsp') return ' ';

      var codePoint = normalized.charAt(1) === 'x'
        ? parseInt(normalized.slice(2), 16)
        : parseInt(normalized.slice(1), 10);
      if (!Number.isFinite(codePoint) || codePoint < 0 || codePoint > 0x10ffff) return '';
      try {
        return String.fromCodePoint(codePoint);
      } catch (error) {
        return '';
      }
    });
  }

  function htmlToPlainText(value) {
    var source = stringValue(value);
    if (!source) return '';

    var withoutUnsafeBlocks = source
      .replace(/<!--[\s\S]*?-->/g, ' ')
      .replace(/<(script|style|template|iframe|object|embed|svg|math)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, ' ')
      .replace(/<(br|hr)\s*\/?>/gi, '\n')
      .replace(/<\/(p|div|li|section|article|h[1-6])\s*>/gi, '\n')
      .replace(/<[^>]*>/g, ' ');

    return decodeTextEntities(withoutUnsafeBlocks)
      .replace(/[\t\f\v ]+/g, ' ')
      .replace(/ +([,.;:!?])/g, '$1')
      .replace(/ *\n */g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function firstString(source, keys) {
    for (var index = 0; index < keys.length; index += 1) {
      var value = stringValue(source && source[keys[index]]);
      if (value) return value;
    }
    return '';
  }

  function boundedLength(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return DEFAULT_SUMMARY_LENGTH;
    return Math.max(60, Math.min(240, Math.floor(number)));
  }

  function truncateSummary(value, maximumLength) {
    var text = stringValue(value).replace(/\s+/g, ' ');
    var limit = boundedLength(maximumLength);
    if (text.length <= limit) return text;

    var available = limit - 3;
    var candidate = text.slice(0, available + 1);
    var sentenceEnd = Math.max(candidate.lastIndexOf('. '), candidate.lastIndexOf('! '), candidate.lastIndexOf('? '));
    if (sentenceEnd >= Math.floor(available * 0.55)) return candidate.slice(0, sentenceEnd + 1).trim();

    var wordEnd = candidate.lastIndexOf(' ');
    if (wordEnd < Math.floor(available * 0.55)) wordEnd = available;
    return candidate.slice(0, wordEnd).trim() + '...';
  }

  function buildListSummary(eventDto, options) {
    var source = eventDto || {};
    var explicitSummary = firstString(source, ['list_summary', 'listSummary', 'summary_text', 'summaryText', 'summary']);
    var summarySource = explicitSummary || firstString(source, ['detail_description', 'detailDescription', 'description_html', 'descriptionHtml', 'description']);
    return truncateSummary(htmlToPlainText(summarySource), options && options.summaryMaxLength);
  }

  function buildDetailDescription(eventDto, options) {
    var source = eventDto || {};
    var rawDescription = firstString(source, ['detail_description', 'detailDescription', 'description_html', 'descriptionHtml', 'description']);
    var plainText = htmlToPlainText(rawDescription);
    var sanitizer = options && options.sanitizeHtml;

    if (rawDescription && typeof sanitizer === 'function') {
      try {
        var sanitizedHtml = stringValue(sanitizer(rawDescription));
        if (sanitizedHtml) {
          return {
            mode: 'SANITIZED_HTML',
            value: sanitizedHtml,
            plainText: plainText,
            requiresTextContent: false,
            sanitizerApplied: true
          };
        }
      } catch (error) {}
    }

    return {
      mode: 'PLAIN_TEXT',
      value: plainText,
      plainText: plainText,
      requiresTextContent: true,
      sanitizerApplied: false
    };
  }

  function isSafeImageUrl(value) {
    var url = stringValue(value);
    return /^https?:\/\/[^\s<>"']+$/i.test(url) || /^\/(?!\/)[^\s<>"']*$/.test(url);
  }

  function buildImagePresentation(eventDto) {
    var source = eventDto || {};
    var imageUrl = firstString(source, ['image_url', 'imageUrl']);
    if (!isSafeImageUrl(imageUrl)) {
      return {
        status: 'FALLBACK',
        src: '',
        alt: '',
        fallbackKey: IMAGE_FALLBACK_KEY,
        reason: imageUrl ? 'UNSAFE_URL' : 'MISSING'
      };
    }

    return {
      status: 'AVAILABLE',
      src: imageUrl,
      alt: htmlToPlainText(firstString(source, ['image_alt', 'imageAlt', 'title'])),
      fallbackKey: '',
      reason: ''
    };
  }

  function firstValue(source, aliases) {
    for (var index = 0; index < aliases.length; index += 1) {
      var value = source && source[aliases[index]];
      if (value !== undefined && value !== null) return value;
    }
    return null;
  }

  function listItems(value) {
    var values = Array.isArray(value) ? value : stringValue(value).split(/\r?\n/);
    return values
      .map(function (item) {
        return htmlToPlainText(stringValue(item).replace(/^\s*[-*]\s+/, ''));
      })
      .filter(Boolean);
  }

  function isSafeContactHref(value) {
    var href = stringValue(value);
    return /^https?:\/\/[^\s<>"']+$/i.test(href) || /^mailto:[^\s<>"']+$/i.test(href) || /^tel:\+?[0-9().\-\s]+$/i.test(href);
  }

  function buildOptionalSection(source, spec) {
    var value = firstValue(source, spec.aliases);
    if (spec.kind === 'list') {
      var items = listItems(value);
      return items.length
        ? { key: spec.key, labelKey: spec.labelKey, kind: spec.kind, items: items }
        : null;
    }

    if (spec.kind === 'contact' && value && typeof value === 'object' && !Array.isArray(value)) {
      var contactText = htmlToPlainText(firstString(value, ['label', 'text', 'name']));
      var contactHref = firstString(value, ['href', 'url']);
      if (!contactText && isSafeContactHref(contactHref)) contactText = contactHref;
      if (!contactText) return null;
      return {
        key: spec.key,
        labelKey: spec.labelKey,
        kind: spec.kind,
        text: contactText,
        href: isSafeContactHref(contactHref) ? contactHref : ''
      };
    }

    var text = htmlToPlainText(value);
    if (!text) return null;
    return { key: spec.key, labelKey: spec.labelKey, kind: spec.kind, text: text, href: '' };
  }

  function buildOptionalSections(eventDto) {
    var source = eventDto || {};
    return OPTIONAL_SECTION_SPECS.map(function (spec) {
      return buildOptionalSection(source, spec);
    }).filter(Boolean);
  }

  function buildStructuredEventContent(eventDto, options) {
    var optionalSections = buildOptionalSections(eventDto);
    return {
      listSummary: buildListSummary(eventDto, options),
      detailDescription: buildDetailDescription(eventDto, options),
      image: buildImagePresentation(eventDto),
      optionalSections: optionalSections,
      hasOptionalContent: optionalSections.length > 0,
      sanitizationBoundary: {
        defaultRendering: 'TEXT_CONTENT_ONLY',
        htmlRequiresSanitizer: true
      }
    };
  }

  return {
    DEFAULT_SUMMARY_LENGTH: DEFAULT_SUMMARY_LENGTH,
    IMAGE_FALLBACK_KEY: IMAGE_FALLBACK_KEY,
    htmlToPlainText: htmlToPlainText,
    truncateSummary: truncateSummary,
    buildListSummary: buildListSummary,
    buildDetailDescription: buildDetailDescription,
    buildImagePresentation: buildImagePresentation,
    buildOptionalSections: buildOptionalSections,
    buildStructuredEventContent: buildStructuredEventContent
  };
});
